import { isDev, isProd, isTest } from '@/config/env';
import brandProdConfig from './prod';
import brandTestConfig from './test';

let brandEnvConfig = brandProdConfig;
if (isProd) {
  brandEnvConfig = brandProdConfig;
} else if (isDev || isTest) {
  // TODO: 联调提测阶段暂时使用测试环境配置，有本地环境需修改
  brandEnvConfig = brandTestConfig;
}

export { brandEnvConfig };
